import { PersonAdReport } from 'static/classes/AdReport';
import { SCEvent } from 'shared/classes/Event';
import { Modal } from 'bootstrap';
import { AdminEvent } from 'static/classes/Event';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';

export function AdReportViewModel(data){
    var self = this;
    self.type = "AdReportViewModel";

    self.rootvm = data.rootvm;
    self.error = ko.observable();

    self.person_list = ko.observableArray([]);
    self.selected_campaigns = ko.observableArray([]);
    self.ad_campaign_report = ko.observableArray([]);

    self.search_name = ko.observable();
    self.search_landing = ko.observable();
    self.search_campaign = ko.observable();
    self.adSelection = ko.observable('all');
    self.start_date = ko.observable();
    self.end_date = ko.observable();

    self.total_count = ko.observable();
    self.filtered_count = ko.observable(0);
    self.sum_confirm_fee = ko.observable();
    self.sum_commission_fee = ko.observable();
    self.total_possible_fee = ko.observable();
    self.people_invite_count = ko.observable();
    self.people_avg_invite_count = ko.observable();
    self.people_admin_match_count = ko.observable();
    self.people_avg_admin_match_count = ko.observable();
    self.people_confirm_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(40);
    self.traffic_views = ko.observable(0);

    self.sum_clicks = ko.observable(0);
    self.sum_unique_artist_page = ko.observable(0);
    self.sum_signups = ko.observable(0);
    self.sum_invite_users = ko.observable(0);
    self.sum_total_invite_fee = ko.observable(0);
    self.sum_confirm_users = ko.observable(0);
    self.sum_total_confirm_fee = ko.observable(0);

    self.is_loading = ko.observable(false);



    self.initialized = ko.observable(false);
    self.initialize = function(){

        if (!self.initialized()){

          if (self.offset() == undefined){
                self.offset(0);
          }
          if (self.limit() == undefined){
                self.limit(50);
          }

            const today = new Date();
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(today.getDate() - 7);
            self.start_date(sevenDaysAgo.toLocaleDateString('en-ca'));
            self.end_date(today.toLocaleDateString('en-ca'));

          /*
          self.lookup_person_referrer_report().then(function(){
            self.initialized(true);
          });*/

        }
    }

    // filter clicks
    //
    self.set_lp_filter = function(person_landing){
        self.search_landing(person_landing.short_landing);
        self.lookup_ad_report();
    }

    self.show_hidden = ko.observable(false);

    self.editing_extra_comment = ko.observable(undefined);
    self.new_extra_comment = ko.observable(undefined);
    self.cancel_extra_comment = function(){
        self.editing_extra_comment(undefined);
    }

    self.lookup_campaign_report  = function(){
        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/ad-campaign-report',
            type: 'GET',

            contentType: "application/json; charset=utf-8",

            success: function (data) {
                self.ad_campaign_report(data.ad_campaign_report);

                self.sum_clicks(data.ad_campaign_report_sums.sum_clicks);
                self.sum_unique_artist_page(data.ad_campaign_report_sums.sum_unique_artist_page);
                self.sum_signups(data.ad_campaign_report_sums.sum_signups);
                self.sum_invite_users(data.ad_campaign_report_sums.sum_invite_users);
                self.sum_total_invite_fee(data.ad_campaign_report_sums.sum_total_invite_fee);
                self.sum_confirm_users(data.ad_campaign_report_sums.sum_confirm_users);
                self.sum_total_confirm_fee(data.ad_campaign_report_sums.sum_total_confirm_fee);

            },
            error: function (data) {
                self.error(data.statusText);
            }
        });

    };

    self.lookup_ad_report  = function(){
        self.rootvm.is_busy(true);

        if(self.end_date() == ''){
            self.end_date(undefined)
        }
        if(self.start_date() == ''){
            self.start_date(undefined)
        }
        if(self.limit() == -1 || self.limit() == ""){
            self.limit(undefined);
        }


        // we need to add in a filter as well..
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/ad-report',
            type: 'GET',
            data:{
                search: self.search_name(),
                landing_page_search: self.search_landing(),
                campaign_id_search: self.search_campaign(),
                start_date: self.start_date(),
                end_date: self.end_date(),
                selected_campaigns: self.selected_campaigns(),
                offset: self.offset(),
                limit:  self.limit(),
                ad_selection: self.adSelection()
            },

            contentType: "application/json; charset=utf-8",
            success: function (data) {

                self.person_list(ko.utils.arrayMap( data.emails || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new PersonAdReport(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);
                self.traffic_views(data.traffic_views);

                self.sum_confirm_fee(data.sum_confirm_fee);
                self.sum_commission_fee(data.sum_commission_fee);
                self.total_possible_fee(data.total_possible_fee);
                self.people_invite_count(data.people_invite_count);
                if(data.people_avg_invite_count){
                    self.people_avg_invite_count(data.people_avg_invite_count.toFixed(1));
                }

                self.people_admin_match_count(data.people_admin_match_count);
                if(data.people_avg_admin_match_count){
                    self.people_avg_admin_match_count(data.people_avg_admin_match_count.toFixed(1));
                }


                self.people_confirm_count(data.people_confirm_count);

            },
            error: function (data) {
                self.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.people_signup_percent = ko.pureComputed(function(){
        //return Math.round((self.people_invite_count() / self.filtered_count()) * 100);
        return ((self.filtered_count() / self.traffic_views()) * 100).toFixed(2);
    });


    self.people_invite_percent = ko.pureComputed(function(){
        //return Math.round((self.people_invite_count() / self.filtered_count()) * 100);
        return ((self.people_invite_count() / self.traffic_views()) * 100).toFixed(2);
    });

    self.people_admin_match_percent = ko.pureComputed(function(){
        //return Math.round((self.people_admin_match_count() / self.filtered_count()) * 100);
        return ((self.people_admin_match_count() / self.traffic_views()) * 100).toFixed(2);
    });


    self.people_confirm_percent = ko.pureComputed(function(){
        return Math.round((self.people_confirm_count() / self.filtered_count()) *100);
    });

    self.people_confirm_total_percent = ko.pureComputed(function(){
        return Math.round((self.sum_confirm_fee() / self.total_possible_fee()) * 100);

    });

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });

    self.paging_visible = ko.computed(function () {
        return self.filtered_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });

    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));
        if(self.offset() < 0){
            self.offset(0);
        }

        self.lookup_ad_report().then(function(){
            pager.navigate("#community/ad-report"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_ad_report().then(function(){
            pager.navigate("#community/ad-report"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };

    self.set_selected_event_history = function(event_json_blob){
        self.is_loading(true)
        console.log("In set selected evnet history");
        const event = new AdminEvent({ rootvm: self.rootvm, event_uuid: event_json_blob.event_uuid });
        setDataAndShowDetailsModal(event, "history")
        self.is_loading(false);
    };



};
